/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ApprovedInputs */

const de__field_approved = /** @type {(inputs: _Field_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fach bestätigt`)
};

/**

* @param {_Field_ApprovedInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_approved = /** @type {((inputs?: _Field_ApprovedInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ApprovedInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_approved(inputs)
});